export default __webpack_public_path__ + "static/media/illustration-img.81db60f1.png";